import { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import store from '@store/store.ts'
import { Provider } from 'react-redux'
import { hydrateCurrentUser } from '@utils/hydrator.js'
import SuspenseFallback from '@components/SuspenseFallback.tsx'
import { RedirectorContainer } from '@features/redirection/index.js'

const GroupListContainer = lazy(() =>
  import('@features/group_list/index.js').then(module => ({ default: module.GroupListContainer }))
)

window.Timetoast.groups = {
  ...window.Timetoast.groups,
  index: {
    init: function (options, targetEl) {
      // hydrate store
      hydrateCurrentUser()

      // tab content
      const root = createRoot(targetEl)
      root.render(
        <Provider store={store}>
          <RedirectorContainer />
          <Suspense fallback={<SuspenseFallback />}>
            <GroupListContainer />
          </Suspense>
        </Provider>
      )
    },
  },
}
